/* eslint-disable no-shadow */
import { call, takeEvery } from "redux-saga/effects";
import noop from "lodash.noop";

import {
    CURRENT_ACCOUNT_REQUESTED,
    defaultScopeId,
    failCurrentAccount,
    succeedCurrentAccount,
} from "./account.duck";

import { loadCurrentAccount } from "./account.api";

import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";

import {
    getId,
    injectApiWithContextFactory,
    injectBoundActionCreatorsFactory,
} from "Utils/sagaUtils";

export const withBoundActions = injectBoundActionCreatorsFactory(
    {
        succeedCurrentAccount,
        failCurrentAccount,
    },
    getId,
    defaultScopeId
);

export const withApiContext = injectApiWithContextFactory(
    {
        loadCurrentAccount,
    },
    injectBoundGQLClient
);

export function* loadCurrentAccountSaga({
    actions: { succeedCurrentAccount, failCurrentAccount },
    api: { loadCurrentAccount },
    resolve = noop,
    reject = noop,
}) {
    try {
        const result = yield loadCurrentAccount();
        yield succeedCurrentAccount(result);
        yield call(resolve);
    } catch (e) {
        yield failCurrentAccount(e);
        yield call(reject, e);
    }
}

export default () =>
    function* rootSaga() {
        yield takeEvery(
            CURRENT_ACCOUNT_REQUESTED,
            withBoundActions(withApiContext(loadCurrentAccountSaga))
        );
    };
